import { lazy } from "react";
import { RouteObject } from "react-router";

// Lazy load share pages from share feature
const PublicCandidateProfile = lazy(
  () => import("@/features/share/pages/CandidateSharePage")
);

export const shareRoutes: RouteObject[] = [
  {
    path: "/share",
    children: [
      {
        path: "candidate/:secret",
        Component: PublicCandidateProfile,
      },
    ],
  },
];
